<style>
html {
  font-family: Tahoma;
  font-size: 14px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #5c6366;
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip) {
  border-top-left-radius: initial;
  border-top-right-radius: initial;
  border-block-end: initial;
}

.input-group-addon {
  background-color: white;
  border: 0px;
}

.vue-form-generator .form-control {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.54);
  border-radius: 0;
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  padding: 0px;
  box-shadow: none;
}
.form-group label {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
}
.form-group .valid .field-input .label {
  font-weight: 700;
  font-size: 8px;
  margin-bottom: 0px;
}

.vue-form-generator .field-switch input:checked ~ .label {
  background: #5c6366;
}
pre {
  overflow: auto;
}
pre .string {
  color: #885800;
}
pre .number {
  color: blue;
}
pre .boolean {
  color: magenta;
}
pre .null {
  color: red;
}
pre .key {
  color: green;
}

h1 {
  text-align: center;
  font-size: 36px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 500;
}

.panel {
  border-color: #fff !important;
}

fieldset {
  border: 0;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0px 1px rgba(0, 0, 0, 0.05);
  border-color: #ddd;
}

.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;

  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.panel-body {
  padding: 20px;
}

.field-checklist .wrapper {
  width: 100%;
}

.select option {
  background: #5c6366;
}

.lt-view-card-result-error {
  color: red;
}

.lt-view-card-result {
  margin-top: 14px;
}

.lt-result-header {
  margin-top: 31px;
  margin-bottom: 31px;
}

.lt-result-body {
  padding: 17px;
}

.form-group.error.required.field-input,
.form-group.error.required.field-dateTimePicker,
.form-group.error.required.field-switch,
.form-group.error.required.field-select {
  background-color: white !important;
}

.form-group.error input:not([type="checkbox"]),
.form-group.error select,
.form-group.error textarea {
  background-color: white;
  border-bottom: 1px solid red;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
}

.form-group.error .errors {
  font-size: 12px;
  font-family: "Roboto", sans-serif;
}

.form-group.error .errors span {
  background-image: url("") !important;
  padding-left: 0px !important;
  font-weight: 300 !important;
}
</style>

<template>
  <div>
    <loading :showLoading="loading">
    </loading>

    <div class="Create alignment">
      <h3
        class="styleHeader"
        style="margin-bottom: 31px"
      > {{ ProceduresName }} </h3>
      <div v-html="ProceduresDescription"></div>
      <v-card class="lt-card-view-sp">
        <div
          class="panel-body"
          v-if="proceduresParametersList.length > 0"
        >
          <vue-form-generator
            ref="vfg"
            :schema="schema"
            :model="model"
            :options="formOptions"
            @validated="onValidated"
          >
          </vue-form-generator>
        </div>
      </v-card>

      <v-btn
        class="white--text lt-card-view-sp styleAlignementSaveButton styleButtonTop"
        @click="submit()"
        color="#5c6366"
        id="btnId"
      >
        <v-icon left>check_circle</v-icon>
        Esegui
      </v-btn>

      <div v-if="result">
        <div class="lt-result-header">
          <h3>Risultati</h3>
        </div>
        <v-card class="lt-view-card-result">
          <div v-html="messageResult" v-bind:class="{ 'lt-view-card-result-error lt-result-body': isError, 'lt-result-body':!isError }">
          </div>
        </v-card>
        <v-card class="lt-view-card-result" v-if="outputMessageResult">
          <div v-html="outputMessageResult" class="lt-result-body">
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import proceduresParametersApi from "../../apiLogisticsTool/procedureParametersApi.js";
import proceduresApi from "../../apiLogisticsTool/proceduresApi.js";
import widgetsApi from "../../apiLogisticsTool/widgetsApi.js";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import { error } from "util";
import loading from "../../components/loadingComponent.vue";

export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    loading
  },

  data: () => ({
    ProceduresName: [],
    ProceduresDescription: "",
    proceduresParametersList: [],
    widgetsList: [],
    loading: false,
    widgetsNameList: [],
    result: false,
    messageResult: "",
    outputMessageResult: "",
    isError: false,
    model: {},
    schema: {
      fields: []
    },
    formOptions: {
      validateAfterLoad: true,
      validateAfterChanged: true
    },
    customerSelected: "",
    message: {},
    forceRefresh: false,
    customFilters: [],
    showGrid: false,
    submitDisabled: true,
    title: "",
    databaseList: []
  }),

  created() {
    const Id = this.$route.params.Id;

    proceduresApi.GetDatabaseFromStockSystem().then(response => {
      this.databaseList = response.data;

      this.getStoredProcedure(Id);
    });
  },

  methods: {
    onValidated(isValid, errors) {},

    getStoredProcedure(Id) {
      proceduresParametersApi
        .GetProcedureParametersByProcedureId(Id)
        .then(response => {
          this.ProceduresName = response.data.name;
          if (response.data.description) {
            this.ProceduresDescription = response.data.description.replace(
              /(?:\r\n|\r|\n)/g,
              "<br>"
            );
          }
          this.StoredProcedure = response.data.storedProcedure;
          this.proceduresParametersList = response.data.parameterList;

          //chiamo il metodo per la creazione di widgets
          for (var i = 0; i < this.proceduresParametersList.length; i++) {
            var isVisible = this.proceduresParametersList[i].isVisible;
              this.createWidgets(this.proceduresParametersList[i]);
          }
        })
        .catch(error => {
          console.log("errore nel caricamento", error);
        });
    },

    createWidgets(params) {
      if (params.name == "Textbox") {
        this.model[params.parameterName] = "";
        let f = {
          validator: VueFormGenerator.validators.string,
          type: "input",
          inputType: "text",
          label: params.label,
          model: params.parameterName,
          placeholder: params.parameterName.replace("@", ""),
          required: params.isRequired,
          readonly: false,
          featured: false,
          disabled: false
        };
        if(params.isVisible){
           this.schema.fields.push(f);
        }  
      } else if (params.name == "Checkbox") {
        this.model[params.parameterName] = "";

        let f = {
          type: "switch",
          label: params.label,
          model: params.parameterName,
          multi: true,
          required: params.isRequired,
          readonly: false,
          featured: false,
          disabled: false,
          textOn: "Attivo",
          textOff: "Disattivato"
        };
        if(params.isVisible){
          this.schema.fields.push(f);
        }
      } else if (params.name == "Database") {
        this.model[params.parameterName] = null;

        let f = {
          type: "select",
          label: params.label,
          model: params.parameterName,
          required: params.isRequired,
          values: this.databaseList,
          selectOptions: { value: "databaseCode", name: "databaseCode" },
          validator: VueFormGenerator.validators.required
        };
        if(params.isVisible){
          this.schema.fields.push(f);
        }
      } else if (params.name == "Data") {
        this.model[params.parameterName] = null;

        let f = {
          validator: VueFormGenerator.validators.string,
          type: "dateTimePicker",
          label: params.label,
          model: params.parameterName,
          required: params.isRequired,
          placeholder: "",
          dateTimePickerOptions: {
            format: "DD/MM/YYYY"
          }
        };
        if(params.isVisible){
          this.schema.fields.push(f);
        }
      } else {
        console.log("widget non valido");
      }
    },

    submit() {
      let objectTopass = {
        Id: this.$route.params.Id,
        Name: this.StoredProcedure,
        Parameters: this.model,
        Username: this.$GAUserAuth.user.username
      };

      var validate = true;

      if (this.proceduresParametersList.length > 0)
        validate = this.$refs.vfg.validate();

      if (validate) {
        this.loading = true;
        proceduresApi
          .ExecuteProcedure(objectTopass)
          .then(response => {
            //visualizzo una card che conterrà i miei elementi
            this.result = true;
            this.isError = !response.data.res;
            this.messageResult = response.data.message;
            this.outputMessageResult = response.data.outputMessage;
          })
          .catch(error => {
            console.log("errore nell'inserimento");
          })
          .finally(() => {
            this.loading = false;
            this.scrollToAnchor();
          });
      }
    },

    scrollToAnchor() {
      var element_to_scroll_to = document.getElementById("btnId");
      element_to_scroll_to.scrollIntoView();
    }
  }
};
</script>

 

